var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhone = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 16 16"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "phone_svg__a",
  d: "M1.333 11.623c0-.477.281-.913.715-1.11a2.393 2.393 0 0 1 3.084 1.034l.165.306a.667.667 0 0 0 .857.29 11.78 11.78 0 0 0 5.99-5.989.667.667 0 0 0-.291-.857l-.306-.165a2.393 2.393 0 0 1-1.034-3.084 1.222 1.222 0 0 1 1.972-.358L13.794 3a2.94 2.94 0 0 1 .834 2.553 11.06 11.06 0 0 1-9.076 9.076A2.94 2.94 0 0 1 3 13.793l-1.31-1.308a1.21 1.21 0 0 1-.357-.862m-1.333 0c0 .682.265 1.323.748 1.805l1.308 1.308A4.3 4.3 0 0 0 5.086 16q.343 0 .686-.057a12.39 12.39 0 0 0 10.171-10.17 4.28 4.28 0 0 0-1.207-3.717L13.428.748A2.54 2.54 0 0 0 11.623 0c-.999 0-1.91.587-2.324 1.496a3.73 3.73 0 0 0 1.365 4.661 10.44 10.44 0 0 1-4.507 4.507A3.73 3.73 0 0 0 1.497 9.3 2.56 2.56 0 0 0 0 11.623"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "phone_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#phone_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#phone_svg__a",
  fill: "#DF0000"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#CDCACA",
  mask: "url(#phone_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z"
})))));
export default SvgPhone;